import { ContentBlock } from 'components/ContentBlock/ContentBlock';
import { Fragment } from 'react';

import plusIcon from 'assets/images/icons/plus.svg';

import './StakeholdersTab.scss';
import { Button } from '../../../../components/Button/Button';
import { useNavigate } from 'react-router-dom';
import { useStakeholdersTabVM } from './useStakeholdersTabVM';
import { Person } from 'services/person/person.types';
import sanitizeHtml from 'sanitize-html';

export default function StakeholdersTab({ person }: { person: Person }) {
    const {
        datalists: { datalists },
        editStakeholder
    } = useStakeholdersTabVM(person);
    const navigate = useNavigate();

    function renderStakeholders() {
        return person?.stakeholders.map((stakeholder) => (
            <Fragment key={stakeholder.id}>
                <ContentBlock
                    isEditable
                    onEditClick={() => editStakeholder(stakeholder)}
                    title={`${stakeholder.firstname} ${stakeholder.lastname}`}
                    key={stakeholder.id}
                >
                    <div className="line">
                        <p className="subtitle">Status</p>
                        <p>{datalists?.stakeholder_status[stakeholder.status]}</p>
                    </div>
                    <div className="line">
                        <p className="subtitle">Nom</p>
                        <p>{stakeholder.lastname}</p>
                    </div>
                    <div className="line">
                        <p className="subtitle">Prenom</p>
                        <p>{stakeholder.firstname}</p>
                    </div>
                    {stakeholder.phone && (
                        <div className="line">
                            <p className="subtitle">Tél</p>
                            <p>{stakeholder.phone}</p>
                        </div>
                    )}
                    {stakeholder.email && (
                        <div className="line">
                            <p className="subtitle">Adresse mail</p>
                            <p>{stakeholder.email}</p>
                        </div>
                    )}
                    {stakeholder.address.formatted && stakeholder.address.formatted.length > 0 && (
                        <div className="line">
                            <p className="subtitle">Adresse postale</p>
                            <p>{stakeholder.address.formatted}</p>
                        </div>
                    )}
                </ContentBlock>
                <ContentBlock title="Commentaire" postIt>
                    <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(stakeholder.observation) }} />
                </ContentBlock>
            </Fragment>
        ));
    }

    return (
        <section className="persons-stakeholders">
            <Button
                label="Ajouter un proche"
                variant="light"
                icon={<img src={plusIcon} alt="" />}
                iconBefore
                callback={() => {
                    navigate(`/app/admin/persons/${person.id}/stakeholders/new`);
                }}
            />

            {person.user?.stakeholders_comment && (
                <ContentBlock title="Commentaire de la personne soutenue" postIt>
                    <p style={{ whiteSpace: 'pre-wrap' }}>{person.user.stakeholders_comment}</p>
                </ContentBlock>
            )}

            {person.stakeholders.length ? (
                <div className="stakeholders-container">{renderStakeholders()}</div>
            ) : (
                <div className="stakeholders-container">Aucun proche n'a été enregistré</div>
            )}
        </section>
    );
}
